<script>
  let width = 0;
  let height = 0;

  let evil = false;
  let toggle = () => {evil = !evil}
</script>


<div class="continer" on:click="{toggle}" bind:offsetWidth="{width}" bind:offsetHeight="{height}">
  <svg viewBox="0 0 {width} {height}" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
    <symbol id="rabbit-front" viewBox="0 0 1024 1024">
      <path fill="none" d="M0 0h1024v1024H0z"/>
      <path d="M470 305c0 20 16 50 32 84 14 29 29 65 35 65 12 0 43-115 44-143 0-34-111-51-111-6zM463 967c-6 45-241 39-292-308-34-231 105-305 141-309 28-3 93 96 79 134-21 56-115 70-110 206 8 232 189 223 182 277zM511 955c8-33 151-32 207-195 35-100-68-181-64-216 6-51 66-160 86-156 133 29 103 200 108 269 4 55 38 132-45 234-103 126-305 115-292 64z" fill="#fff"/>
      {#if evil}
        <path fill="#db545f" d="M350 618h306v140H350z"/>
      {/if}
      <path d="M510 907c-14-13 54-57 47-67-7-11-51 29-71 29-18 0-33-34-47-30-15 3 18 41-3 54-41 25-126-91-128-187-5-171 116-183 111-229-8-79-152-218-192-291-18-33-38-149-20-153 17-3 96 69 128 129 22 41 104 105 142 207 20 54 34 129 60 127 31-2 56-147 94-198 42-55 97-133 158-133 54 0 83 144 59 162-22 16-39-32-61-31-28 0-146 168-161 237-9 39 81 98 72 183-11 102-150 228-188 191zM379 645c-18 4-25 36-21 48 5 14 27 40 40 38 11-2 13-37 12-46-1-11-12-43-31-40zm163 26c1-16 15-40 32-38 17 1 23 20 22 37-2 17-20 52-32 51-11 0-22-34-22-50zm43-158c-11-5 27-92 52-133 26-43 96-138 107-128 12 10-61 90-87 134-25 41-62 131-72 127zM320 216c7-5 75 102 104 141 43 59 71 142 53 142-15 0-21-57-56-117-26-44-109-160-101-166z" fill="#fff"/>
    </symbol>

    <symbol id="rabbit-back" viewBox="0 0 1024 1024">
      <g fill="#fff">
        <path d="M548 732c-54 4-131 61-94 136 26 54 67 68 62 99-3 19-50 25-102 23-42-2-89 27-122-18-19-27 21-69-5-84a289 289 0 01-122-246c6-146 202-320 375-314 173 7 372 160 381 306 8 129-75 224-117 249-26 16 15 56-4 84-32 45-80 18-121 20-53 3-99-2-103-20-6-32 35-47 60-101 35-75-33-131-88-134z"/>
        <path d="M576 767a71 71 0 11-55 131 71 71 0 0155-131zM330 359c21 4 61-28 66-53 6-32-75-177-180-116-109 64-124 190-109 196 27 12 101-94 138-92 34 2 63 61 85 65zM735 358c59 29 99-106 113-129 14-25 84-187 57-201-21-12-109 109-136 153-22 34-95 148-34 177z"/>
      </g>
    </symbol>

    <use xlink:href="#rabbit-front" x="350" y="50" height="300" width="300" class="color1" />
    <use xlink:href="#rabbit-back" y="50" height="300" width="300" class="color1" />
  </svg>
</div>

<style>
  .continer {
    width: 100%;
    height: 100%;
    background-color: #102559;
  }
</style>